import React from 'react';
import { BRAND_NAME, LOGO_PATH, LOGO_PATH_DARK } from '../branding';

/**
 * BrandLogo — логотип платформы. Единственная точка, где решается,
 * какой файл показать: светлый или тёмный.
 *
 * ⚠️ Дефолт — светлый, и это не опечатка. Экраны логина, регистрации,
 * восстановления пароля, онбординга и демо помечены классом `.auth-page`,
 * который жёстко переопределяет палитру на светлую (см. index.css,
 * «Auth pages — always light»). Атрибут data-theme там не выставлен вовсе:
 * useTheme вызывается только внутри Layout. Поэтому чтение data-theme на
 * этих страницах дало бы `null` → и без явного дефолта мы бы уехали в
 * тёмный вариант на белом фоне.
 *
 * variant: 'light' | 'dark' | 'auto'
 *   'auto' — по data-theme на <html> (для поверхностей внутри Layout,
 *            где тема действительно переключается).
 */
export default function BrandLogo({ variant = 'light', height = 72, style, className, alt }) {
  const resolved = variant === 'auto'
    ? (typeof document !== 'undefined'
        && document.documentElement.getAttribute('data-theme') === 'dark'
        ? 'dark' : 'light')
    : variant;

  return (
    <img
      src={resolved === 'dark' ? LOGO_PATH_DARK : LOGO_PATH}
      alt={alt || BRAND_NAME}
      className={className}
      style={{
        // height задаёт лишь верхнюю границу — на узких экранах (Android,
        // где логотип-плашка шире, чем на iOS-макетах) ширина упирается в
        // maxWidth раньше, и без height:'auto' картинка сохраняла бы
        // фиксированную высоту, вылезая за край контейнера вбок.
        height: 'auto',
        maxHeight: height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto',
        ...style,
      }}
    />
  );
}
